import { BaseEdge, EdgeLabelRenderer, getBezierPath, useReactFlow } from '@xyflow/react';
import type { EdgeProps } from '@xyflow/react';
import { ActionIcon } from '@mantine/core';
import { IconX } from '@tabler/icons-react';

type EdgeData = {
  onDelete?: (edgeId: string) => void;
};

export function DeletableEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style,
  markerEnd,
  selected,
  data,
}: EdgeProps) {
  const { setEdges } = useReactFlow();
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const handleDelete = () => {
    setEdges((edges) => edges.filter((edge) => edge.id !== id));
    (data as EdgeData | undefined)?.onDelete?.(id);
  };

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      {selected && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              pointerEvents: 'all',
            }}
          >
            <ActionIcon
              size="xs"
              color="red"
              variant="filled"
              radius="xl"
              onClick={handleDelete}
              style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}
            >
              <IconX size={12} />
            </ActionIcon>
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
}
